const availableSizes = []

for (let i = 34; i <= 60; i+= 2) {
    availableSizes.push(i)
}

export default availableSizes
